import React, { useEffect, useState } from 'react';
import { DatePicker, Select, Switch } from 'antd';
import moment from 'moment';
import { getClubTrainersWithIdAndNameOnly } from '../../../../service/getUsers/getClubTrainers';


const BatchInstallmentSettings = ({ courseModules, moduleSettings, handleModuleSettingChange, isLoading }) => {
    const [trainers, setTrainers] = useState([]);

    useEffect(() => {
        const fetchTrainers =  async () => {
            const trainers = await getClubTrainersWithIdAndNameOnly();
            setTrainers(trainers);
        }
        fetchTrainers();
    }, [])

    return (
        <>
            {courseModules.length > 0 && (
                <div className="mb-8">
                    <h2 className="text-xl font-bold text-white mb-6">Course & thier Modules</h2>
                    {courseModules.map((course, index) => (
                        <div key={course.courseId} className="mb-8">
                            <h3 className="text-lg font-semibold text-gray-100 mb-4">{index + 1 + "."} Course Name : {course.courseName}</h3>
                            {course.modules.length > 0 ? (
                                course.modules.map((module) => {
                                    const settingId = `${course.courseId}_${module.moduleId}`
                                    return (
                                        <div
                                            key={module.moduleId}
                                            className="mb-6 bg-gray-900 border border-gray-800 rounded-xl p-6 shadow-lg transition-all hover:shadow-xl"
                                        >
                                            <div className="flex justify-between gap-4 mb-4">
                                               
                                                <div className='flex'>
                                                    <span className="text-sm font-medium text-gray-300">Module Name:</span>
                                                    <p className="text-sm text-gray-200">{module.moduleName}</p>
                                                </div>

                                                <div className="flex">
                                                    <label className="text-sm font-medium text-gray-300 mr-3">Installment Status</label>
                                                    <Switch
                                                        checked={moduleSettings[settingId]?.moduleInstallmentStatus || false}
                                                        onChange={(checked) =>
                                                            handleModuleSettingChange(settingId, 'moduleInstallmentStatus', checked)
                                                        }
                                                        disabled={isLoading}
                                                        checkedChildren="On"
                                                        unCheckedChildren="Off"
                                                        className="bg-gray-700"
                                                    />
                                                </div>
                                            </div>

                                            <div className="flex w-full flex-col mb-4">
                                                <label className="text-sm font-medium text-gray-300 mb-1">Select Trainer</label>
                                                <Select
                                                    required
                                                    name={'moduleTrainerId'}
                                                    allowClear
                                                    showSearch
                                                    optionFilterProp="label"
                                                    placeholder="Select trainer"
                                                    value={moduleSettings[settingId]?.moduleTrainerId || null}
                                                    onChange={(value) =>
                                                        handleModuleSettingChange(
                                                            settingId,
                                                            'moduleTrainerId',
                                                            value
                                                        )
                                                    }
                                                    options={trainers.map((item) => (
                                                        {
                                                            label: item.trainerName,
                                                            value: item.trainerId,
                                                        }
                                                    )) || []}
                                                />
                                            </div>


                                            <div className="flex gap-4">
                                                <div className="flex w-full flex-col">
                                                    <label className="text-sm font-medium text-gray-300 mb-1">Start Date</label>
                                                    <DatePicker
                                                        value={
                                                            moduleSettings[settingId]?.moduleStartDate
                                                                ? moment(moduleSettings[settingId].moduleStartDate)
                                                                : null
                                                        }
                                                        onChange={(date) =>
                                                            handleModuleSettingChange(
                                                                settingId,
                                                                'moduleStartDate',
                                                                date ? date.toISOString() : null
                                                            )
                                                        }
                                                        disabled={isLoading}
                                                        className="w-full bg-gray-800 border border-gray-700 rounded-md text-white hover:bg-gray-700 focus:ring-2 focus:ring-gray-600"
                                                        popupClassName="bg-gray-800 text-white border-gray-700"
                                                    />
                                                </div>
                                                <div className="flex w-full flex-col">
                                                    <label className="text-sm font-medium text-gray-300 mb-1">End Date</label>
                                                    <DatePicker
                                                        value={
                                                            moduleSettings[settingId]?.moduleEndDate
                                                                ? moment(moduleSettings[settingId].moduleEndDate)
                                                                : null
                                                        }
                                                        onChange={(date) =>
                                                            handleModuleSettingChange(
                                                                settingId,
                                                                'moduleEndDate',
                                                                date ? date.toISOString() : null
                                                            )
                                                        }
                                                        disabled={isLoading}
                                                        className="w-full bg-gray-800 border border-gray-700 rounded-md text-white hover:bg-gray-700 focus:ring-2 focus:ring-gray-600"
                                                        popupClassName="bg-gray-800 text-white border-gray-700"
                                                    />
                                                </div>
                                            </div>

                                            {moduleSettings[settingId]?.moduleInstallmentStatus && (
                                                <div className="mt-4 flex  gap-4">

                                                    <div className="flex w-full flex-col">
                                                        <label className="text-sm font-medium text-gray-300 mb-1">Installment Date</label>
                                                        <DatePicker
                                                            value={
                                                                moduleSettings[settingId]?.moduleInstallmentDate
                                                                    ? moment(moduleSettings[settingId].moduleInstallmentDate)
                                                                    : null
                                                            }
                                                            onChange={(date) =>
                                                                handleModuleSettingChange(
                                                                    settingId,
                                                                    'moduleInstallmentDate',
                                                                    date ? date.toISOString() : null
                                                                )
                                                            }
                                                            disabled={isLoading}
                                                            className="w-full bg-gray-800 border border-gray-700 rounded-md text-white hover:bg-gray-700 focus:ring-2 focus:ring-gray-600"
                                                            popupClassName="bg-gray-800 text-white border-gray-700"
                                                        />
                                                    </div>

                                                    <div className="flex w-full flex-col">
                                                        <label className="text-sm font-medium text-gray-300 mb-1">Installment Price</label>
                                                        <input
                                                            type="number"
                                                            value={moduleSettings[settingId]?.moduleInstallmentPrice || 0}
                                                            onChange={(e) =>
                                                                handleModuleSettingChange(
                                                                    settingId,
                                                                    'moduleInstallmentPrice',
                                                                    parseFloat(e.target.value) || 0
                                                                )
                                                            }
                                                            placeholder="Enter Installment Price"
                                                            disabled={isLoading}
                                                            className="w-full max-w-xs bg-gray-800 border border-gray-700 rounded-md px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-gray-600 placeholder-gray-500"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )
                                }
                                )
                            ) : (
                                <div className="ml-4 text-sm text-gray-400">No modules found for this course.</div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default BatchInstallmentSettings;